import { render, staticRenderFns } from "./newsletter.vue?vue&type=template&id=d4bfb5de&scoped=true"
import script from "./newsletter.vue?vue&type=script&lang=js"
export * from "./newsletter.vue?vue&type=script&lang=js"
import style0 from "./newsletter.vue?vue&type=style&index=0&id=d4bfb5de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4bfb5de",
  null
  
)

export default component.exports